import { styled, css } from 'styled-components';
import { Action } from '../Action';
import { StateLayer } from '../Action/elements';
export const StyledAction = styled(Action).attrs({
  variant: 'outline'
}).withConfig({
  componentId: "aui__sc-3x6syo-0"
})(["& > *{pointer-events:none;}&:hover,&:active{color:var(--aui-on-surface);box-shadow:none;", "{background-color:var(--aui-on-surface);}}", ""], StateLayer, ({
  $checked
}) => $checked && css(["background:var(--aui-action-tonal-action);border-width:0.125rem;padding:calc(var(--aui-spacing-150) - 2px);"]));
export const FeedbackContainer = styled.div.withConfig({
  componentId: "aui__sc-3x6syo-1"
})(["display:flex;flex-direction:row;gap:var(--aui-spacing-100);"]);